import { withStyles } from '@mui/styles';
import Home from './Home';
import styles from './styles';

const Styled = withStyles(styles)(Home);

export default Styled;
